import React from 'react';

const Instructions = ({ locale }) => (
	<div>
		<p>{locale['app.instructions']}</p>
	</div>
);

Instructions.propTypes = {};

Instructions.defaultProps = {};

export default Instructions;



// WEBPACK FOOTER //
// ./src/ui/instructions/Instructions.component.js